import { SignalRModuleType, SignalRRecordType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface ISignalrNotification {
    id: string;
    module: SignalRModuleType;
    subject: string;
    title: string;
    body: string;
    recordId: string;
    recordType: SignalRRecordType;
    modifyUser: IModifyUser;
}

export class SignalrNotification implements ISignalrNotification {
    id: string;
    module: SignalRModuleType;
    subject: string;
    title: string;
    body: string;
    recordId: string;
    recordType: SignalRRecordType;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: ISignalrNotification);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.module = obj && obj.module || SignalRModuleType.Unknown;
        this.subject = obj && obj.subject || "";
        this.title = obj && obj.title || "";
        this.body = obj && obj.body || "";
        this.recordId = obj && obj.recordId || "";
        this.recordType = obj && obj.recordType || SignalRRecordType.Unknown;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}